import React from 'react';
import { MenuWrapper } from './styled';

const items = [
  { label: 'Hệ thống', key: 'item-1' }, // remember to pass the key prop

  {
    label: 'Bài viết',
    key: 'submenu',
    children: [
      { label: 'Danh mục', key: 'submenu-item-1' },
      { label: 'Tạo mới', key: 'submenu-item-2' }
    ]
  },
  { label: 'Banner', key: 'item-2' } // which is required
];

function MenuBar() {
  return <MenuWrapper items={items} mode="horizontal"></MenuWrapper>;
}

export default MenuBar;
